<div id="todo" class="page-layout carded left-sidebar inner-scroll">

    <!-- SIDEBAR -->
    <fuse-sidebar class="sidebar" name="manufacturer-main-sidebar" position="left" lockedOpen="gt-md">
        <manufacturer-main-sidebar></manufacturer-main-sidebar>
    </fuse-sidebar>
    <!-- / SIDEBAR -->

    <!-- CENTER -->
    <div class="center">
        <selling-navbar></selling-navbar>

        <div class="content-card">
            <!-- CONTENT -->
            <div id="ngx-datatable" class="page-layout simple fullwidth docs">
                <div class="content p-24">
                    <ngx-datatable
                            class="material"
                            [rows]="rows"
                            [loadingIndicator]="loadingIndicator"
                            [columnMode]="'force'"
                            [headerHeight]="48"
                            [footerHeight]="56"
                            [rowHeight]="'auto'"
                            [scrollbarH]="true"
                            [reorderable]="reorderable"
                            [selectionType]="'checkbox'"
                            [limit]="10">

                        <ngx-datatable-column [width]="48"
                                              [canAutoResize]="false"
                                              [sortable]="false">
                            <ng-template ngx-datatable-header-template let-value="value" let-allRowsSelected="allRowsSelected"
                                         let-selectFn="selectFn">
                            </ng-template>

                            <ng-template ngx-datatable-cell-template let-value="value" let-isSelected="isSelected"
                                         let-onCheckboxChangeFn="onCheckboxChangeFn">

                            </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="{{'Name' | translate}}" prop="name"></ngx-datatable-column>
                        <ngx-datatable-column name="{{'Actions'|translate}}" sortable="false" prop="id">
                            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>

                                <a routerLink="/manufacturers/edit/{{row.id}}">{{'Edit'|translate}}</a>

                            </ng-template>
                        </ngx-datatable-column>
                    </ngx-datatable>
                </div>
            </div>
        </div>
    </div>
</div>